module.exports = __webpack_public_path__ + "static/media/eclipse@2x.4e9d3385.jpg";